import script from "./user.layout.vue?vue&type=script&setup=true&lang=js"
export * from "./user.layout.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__